module.exports = __webpack_public_path__ + "static/media/Light_Divider@3x.6b0ba3ce.png";